import { useMutation } from "@tanstack/react-query";

import { axios } from "@features/config";

import { Proposal } from "@dto/proposal";

type Request = {
  roundtableId: string;
  payload: { title: string; question: string; from: string; to: string; link: string; reminder: string };
};

type Response = {
  success: boolean;
  data?: { code: number; message: string; data: Proposal };
  message?: string;
};

const createEventProposal = async ({ roundtableId, payload }: Request): Promise<Response> => {
  const response = await axios.post(`/round-tables/${roundtableId}/proposal/event`, payload);

  return response.data.data;
};

const useCreateEventProposal = () => {
  return useMutation(createEventProposal);
};

export default useCreateEventProposal;
